<template>
  <div class="helpTutorials">
    <div class="head">
      <span>{{title}}</span>
      <p>
        <span v-for="(item, i) in proList" :key="i" :class="{active: showType==i}" @click="changeType(i)">{{item}}</span>
      </p>
    </div>
    <ul class="content">
      <li v-for="(item, i) in showQuestionList" :key="i" v-if="!item.disabled">
        <p @click="changeShowAnswer(i, $event)" class="question"><img src="../../static/img/right.png">{{item.question}}</p>
        <p v-html="item.answer" class="answer"></p>
      </li>
    </ul>
    <ul class="paging">
      <li v-for="(item, i) in pageNums" :key="i" :class="{active: pageNo===item}" @click="changePage(item)">{{item}}</li>
    </ul>
  </div>
</template>

<script>
import $ from 'jquery'
const needDisabled = true
export default {
  name: 'helpTutorials',
  data () {
    return {
      title: '帮助和教程',
      proList: ['业主版', '彩友版'],
      showType: 0,
      pageNo: 1,
      pageSize: 10,
      pageNums: 0,
      helpList: [
        {
          title: '业主版',
          questionsAndAnswers: [
            {
              question: '什么是彩店邀请码？',
              answer: '为方便您拓展客户和维护稳定的客户关系，我们为每个彩店都创建了独一无二的彩店邀请码和推广二维码。当您通过【彩点助手-业主版APP】分享图片或页面到微信或QQ时，都会带上您的推广二维码，任何客户扫描二维码并注册【彩点助手-彩友版APP】后，都会成为您的绑定客户。因此，我们建议您充分利用彩店邀请码和推广二维码，尽量多地分享给周围的朋友，这样您的客户就会源源不断的加入您的彩店啦~',
              disabled: false
            },
            {
              question: '如何获得彩店邀请码？',
              answer: '启动【彩点助手-业主版APP】,在“大厅”界面的 “常用工具”中点击“推广二维码”图标，即可看到专属您的推广二维码和彩店邀请码，将它分享给更多的人吧！当然，您也可以将二维码张贴在门店里，让更多的客户扫描。<br>' +
              '另外，您每次分享方案、单关图片或宣传图片时，我们都会附上您的推广二维码，所以尽量多的分享吧',
              disabled: false
            },
            {
              question: '注册成功后能否修改手机号？',
              answer: '手机号是用户登录的唯一识别码，所以一旦注册成功就不能随意修改，若因为特殊原因必须修改手机号，请联系我们的客服。',
              disabled: false
            },
            {
              question: '注册成功后忘记了密码怎么办？',
              answer: '【彩点助手-业主端APP】的登录密码为6-12位数字或字母，登录成功后只要不登出，是不需要重新登录的。若重新登录时忘记了密码，可以在登录界面点击“忘记密码”，通过手机验证进行密码重置，重置后一定要点击“确定”按钮哦~',
              disabled: false
            },
            {
              question: '截止时间是什么意思？',
              answer: '每个方案都带有截止时间，截止时间是取实际开赛前的10分钟，原则上在截止时间之前都可以售票，但因为时差的原因，很多比赛是在北京时间的凌晨进行的，所以您需要提醒购彩者尽早购票。',
              disabled: false
            },
            {
              question: '方案大全中的专家从哪里来的？',
              answer: '在平台中聚集了全国各地经验丰富的彩票专家和体育专家，每天按时推荐方案，在平台专家页面还将专家按照人气值、7天胜率、30天胜率、7天收益率、30天收益率、当前连黑和当前连红值进行排序。您可以通过各项指标筛选想要的方案，然后添加到本店，这样每当专家发布方案，您都能第一时间收到。为保证您第一时间收到方案，请在手机设置中将【彩点助手-业主版】的推送通知设为全开状态。',
              disabled: false
            },
            {
              question: '方案大全中的人气值是如何计算的？',
              answer: '人气值代表了专家的受欢迎程度，人气值越高表示被业主关注的人次越多。我们举例来说明人气值的计算方法：假设平台一共有100位业主用户，若您的方案有29个业主关注，则您的人气值=29/100=29%。所以，选择人气值高的专家，一定是不错的选择哦！',
              disabled: false
            },
            {
              question: '方案大全中的7天胜率和30天胜率是如何计算的？',
              answer: '只有在7天内同一个方案推单次数达到和超过5天的专家才能参与7天胜率的排名，否则属于未达标专家。只有在30天内同一个方案推单次数达到和超过21天的专家才能参与30天胜率的排名，否则属于未达标专家。<br>' +
              '胜率代表了方案在规定时间内中出概率，胜率越高表示中出期数越多，并且专家的胜率取该专家所有方案中胜率最高值，若胜率相同，则推单天数多者排名在前。休息日不计入推单天数。<br>' +
              '举例说明7天胜率的计算方法：假设某方案在7天内中出了4次，但有x天未推荐，那么该方案的7天胜率=4/（7-x）。<br>' +
              '举例说明30天胜率的计算方法：假设某方案在30天内中出了15次，但有y天未推荐，那么该方案的30天胜率=15/（30-y）。',
              disabled: false
            },
            {
              question: '方案大全中当前连红和当前连黑是什么意思？',
              answer: '当前连黑和当前连红分别代表了专家近期连续未中和连续中出的总期数，当前连黑数越高表示专家近期连续未中出的期数越多，当前连红数越高表示专家近期连续中出的期数越多。若某专家有多个方案时，则会显示他所有方案中当前连黑数最大和当前连红数最大的数据。<br>' +
              '需要注明的是，连黑和连红的期数是剔除了休息日。',
              disabled: false
            },
            {
              question: '如何制作单关宣传图？',
              answer: '启动【彩点助手-业主版APP】，在“大厅”界面中的常用工具中，点“单关宣传”按钮，打开“单关宣传”界面，您会看到程序自动生成的当前单关图，并且图片自动带上彩店推广二维码。您可以将单关图保存到相册，或直接分享到微信或QQ。<br>' +
              '若当前有多场单关比赛，还可以点击单关信息后在弹出的场次列表中选择其他单关比赛。【彩点助手-业主版APP】中为您提供了多套单关宣传图模板，点击“切换模板”可切换其他模板样式，您可以定期更换模板让宣传更出彩！<br>',
              disabled: false
            },
            {
              question: '查看昨日方案开奖和历史方案开奖？',
              answer: '启动【彩点助手-业主版APP】,在“大厅”界面点击“开奖结果”按钮，昨日开奖数据即呈现出来，而且还显示有已开奖数和中奖率。在数据表格中红色背景表示中奖，白色背景表示未中奖。<br>' +
              '若想分享开奖数据，点击界面底部的“分享开奖数据”按钮，程序会自动将开奖结果生成图片，您可以将分享图片发送给微信群、微信朋友圈、QQ群和QQ空间。<br>' +
              '若要查询历史开奖数据，点击“日期查询”，上下滑动面板中的数字选择要查询的日期，最后点击“确定”按钮，该日期的历史开奖数据即刻呈现。<br>',
              disabled: false
            },
            {
              question: '业主如何新建用户？',
              answer: '业主在【彩点助手-业主版APP】中添加用户后，该用户即成为彩店的绑定用户，无需另外审核。启动【彩点助手-业主版APP】，点击“彩友”图标，在“彩友管理”界面点击左上角“新增”图标，在弹出的新增用户窗口中输入昵称、性别、手机号和分类，您还可以添加用户的微信号和备注信息。这里需要强调的是，新增用户时输入的用户手机号就是彩友登录【彩点助手-彩友版APP】的账号，因此需要真实有效。',
              disabled: false
            },
            {
              question: '能否查询专家方案的历史数据？',
              answer: '进入任意专家的方案详情界面，点击界面底部的“分享图片”按钮，会弹出分享天数选择界面，允许分享7天、10天、15天、20天和30天方案数据，选择天数后程序会将近n天的数据制成图片（n是您选择的分享天数），然后点击图片底部的“分享”按钮即可将图片分享到微信朋友圈、微信群、QQ群和QQ空间中了，并且在每张图片自动添加了您的彩店信息和推广二维码。分享功能是推广彩店和拓展客户的有力工具，一定要好好利用哦！',
              disabled: false
            },
            {
              question: '本店方案详情页面中的“参数设置”是什么意思？',
              answer: '这是【彩点助手-业主版APP】人性化设计的又一体现，在方案详情页中我们为您设定了两种显示模式，分别为“翻倍模式”和“收益率模式”。<br>' +
              '“翻倍模式”的起步金是100元，若不中第二天的投注金翻倍，例如：若计划第一天不中则第二天投入金额为200元，若第二天不中则第三天投入金额为400元，以此类推直到中出。<br>' +
              '“收益率模式”的起步金也是100元，但每日投入金额则是按照您设定的收益率值动态计算的，收益率范围为13%-20%。您可以根据方案的特点选择合适的显示模式，您的彩友用户也将看到相同的模式。<br>' +
              '计划周期是指方案的止损周期，设置范围为5天-20天，默认为7天，当达到止损周期还未中出时则自动止损，下一期从起步金开始。<br>',
              disabled: false
            },
            {
              question: '如何分享本店方案，让彩友用户下单？',
              answer: '从方案大全中添加了平台方案到本店后，就可以每天收到专家的方案推送了。跟着专家方案进行计划投注，对于不太懂球的购彩者来说是最方便最有效的投注方式。打开本店方案详情页后点击“分享订单”按钮，然后分享至微信群、微信朋友圈、QQ群或QQ空间。您的老用户点击分享页面后可直接下单，新用户点击分享页后会先完成手机号绑定，绑定成功后即可成为您彩店的绑定用户。',
              disabled: needDisabled
            },
            {
              question: '业主如何创建方案？',
              answer: '我们平台特别欢迎像您这样既懂球，又乐意分享推荐方案的彩店业主。在【彩点助手-业主版APP】中为您提供了便利的方案发布工具，只要您的红单率高，定能成为万众瞩目的大神哦~在 “大厅”界面的常用工具中点击“我的推荐”图标，点击“创建方案”按钮，在创建方案窗口输入方案名、玩法大类、方案属性、设置可见范围，最后点击“确定”按钮即创建成功。可见范围分为店内可见和平台可见，店内可见即只有店内彩友可以看见，平台可见即平台内所有业主可见。平台支持竞彩足球和竞彩篮球两种玩法大类，而且包括连连猜方式。串关方式支持单关、二串和混合，玩法方式支持胜平负、总进球、半全场、比分和混投。方案创建完后，记得每天推单哦~如果当天有事无法推单，还可以设置今日休息',
              disabled: false
            },
            {
              question: '业主如何发布今日方案？',
              answer: '任何业主都可以以专家的身份向平台或向本店内彩友发布方案信息，但平台专家需要管理员审核通过方可生效。启动【彩点助手-业主版APP】后进入“大厅”界面，在“常用工具”中点击“我的推荐”图标，进入“我的推荐”界面后选择方案，点击“今日推荐”后即可推荐方案数据，若今日有事无法推单，可以点击“今日休息”。',
              disabled: false
            },
            {
              question: '什么是单关？',
              answer: '单关指的是只对一场比赛结果进行投注。官方规定的单关比赛通常是开放了胜平负玩法的单关（只选胜平负中的结果即可投注这一场比赛，其它非单关比赛通常要串2场及2场以上的比赛），在自由投注中，带红框的场次就是单关场次。还有一种单关是指对一场比赛的比分、半全场、进球数进行投注，此时也可以对单场比赛进行投注。',
              disabled: false
            },
            {
              question: '什么叫胆？',
              answer: '胆，是彩票术语中的一种。在竞猜型彩票中表示你比较看好，出现的几率高一点的比赛结果，称之为胆。取有胆量确定号码就是对的之意哦。<br>' +
              '定胆可减少成本，例如：你选3场比赛，选2串1，那么就是3注，6元。如果你定胆三场中一场，那么就变成用胆和另两场组合成2注2串1了，4元，省了两元。定胆之后，成本少了，奖金也变少了，而且胆错则不可能中奖。<br>',
              disabled: false
            },
            {
              question: '奖金优化有什么作用？',
              answer: '奖金优化就是针对投注的复式倍投方案，您可以根据彩友需求，对单注注数进行分配。【彩点助手】提供了三种快捷的优化方式：平均优化、博热优化和博冷优化，它们的说明和区别如下。<br>' +
              '平均优化：以方案单注奖金趋于平均的规则进行优化。<br>' +
              '博热优化：在方案单注保本前提下，使概率最高的单注奖金最大化。<br>' +
              '博冷优化：在方案单注保本前提下，使奖金最高的单注奖金最大化。<br>',
              disabled: needDisabled
            },
            {
              question: '奖金优化支持哪些过关方式？',
              answer: '奖金优化最多支持10场比赛的串关优化，但“博热优化”和“博冷优化”暂不支持组合过关',
              disabled: needDisabled
            },
            {
              question: '奖金优化是否支持设胆？',
              answer: '奖金优化不支持用户进行设胆。',
              disabled: needDisabled
            },
            {
              question: '奖金优化后的方案是否会赔钱?',
              answer: '不一定。中奖的基本条件，是您选的原始方案是中奖的。如果您的原始方案没有中，那优化后的方案也是不会中奖的，所以肯定也是要赔钱的。',
              disabled: needDisabled
            },
            {
              question: '如何查看自己的订单状态？',
              answer: '在【彩点助手-业主版APP】中，您可以随时跟踪每个订单的实时状态。在“订单管理”界面将订单分为了四种状态，分别是待出票、待开奖、待派奖和已完成。您可以查找到所有彩友的所有历史订单，而且每个订单都有详细信息供您查询。',
              disabled: needDisabled
            },
            {
              question: '如何支付？',
              answer: '【彩点助手-业主版APP】是个合规合法的软件，目前不支持任何线上支付功能，您可以让彩友通过微信或支付宝转账等方式进行订单支付。',
              disabled: needDisabled
            },
            {
              question: '若彩友成功下单后，我能收到消息吗？',
              answer: '当然可以！彩友在【彩点助手-彩友版APP】或【彩点助手-微信公账号】中成功下单后，您将收到“XXX刚刚下了订单，请尽快出票！”的消息提醒，收到订单后尽快出票哦~',
              disabled: needDisabled
            },
            {
              question: '若我完成了出票，彩友能收到消息吗？',
              answer: '当然可以！当您完成出票后，彩友的【彩点助手-彩友版APP】会收到推送消息。而且，只要彩友关注了【彩点助手-微信公众号】，在【彩点助手-微信公众号】中还能及时收到消息提醒。这样您就不用一一打电话通知了。',
              disabled: needDisabled
            },
            {
              question: '如何派奖？',
              answer: '【彩点助手-业主版APP】是个合规合法的软件，目前不支持任何线上支付功能，您可以通过微信或支付宝转账等方式将奖金派发给购彩者。',
              disabled: needDisabled
            },
            {
              question: '彩友可以更换彩店吗？',
              answer: '彩友的所有订单都与绑定的彩店相关联，因此我们会建议购彩者不要更换彩店。但彩友如果因为特殊原因必须更换，他们是可以通过“解绑彩店”功能解除与您的绑定关系。所以，维护彩友关系事关重大，相信您一定会牢牢把他们留住的，我看好你哦！',
              disabled: false
            },
            {
              question: '解绑彩店后还能再恢复绑定原来的彩店吗？',
              answer: '当然可以！任何时候您的客户数据都是保留的，只要他们重新绑定您的彩店邀请码，他们就又是你的人了，是不是很开心很开心~~',
              disabled: false
            }
          ]
        },
        {
          title: '彩友版',
          questionsAndAnswers: [
            {
              question: '什么是彩店邀请码？',
              answer: '邀请码是实体彩店唯一的编号，当您注册账号输入邀请码后，就与这个邀请码对应的实体彩店进行了绑定，这样您就可以收到实体彩店发来的消息，您也可以在这家实体彩店进行下单。',
              disabled: false
            },
            {
              question: '注册成功后能否修改手机号？',
              answer: '手机号是用户登录的唯一识别码，所以一旦注册成功就不能随意修改，若因为特殊原因必须修改手机号，可以向绑定的实体彩店求助。',
              disabled: false
            },
            {
              question: '注册成功后忘记了密码怎么办？',
              answer: '【彩点助手-彩友版APP】的登录密码为6-12位数字或字母，登录成功后只要不登出，是不需要重新登录的。若重新登录时忘记了密码，可以在登录界面点击“忘记密码”，通过手机验证进行密码重置，重置后一定要点击“确定”按钮哦~',
              disabled: false
            },
            {
              question: '可以用微信登录软件吗？',
              answer: '当然可以！除手机号登录外，在登录界面的底部您还能看到微信图标，点击图标进入对应的授权界面，确定授权后即可登录成功，但在初次登录时您还需要做信息补充，请输入手机号做短信验证，以及输入彩店邀请码绑定实体彩店，最后点击“完成注册”就OK啦！以后点击微信或QQ图标就能直接登录了。',
              disabled: false
            },
            {
              question: '截止时间是什么意思？',
              answer: '每个方案都带有截止时间，截止时间是取实际开赛前的半小时，原则上在截止时间之前都可以购票，但因为时差的原因，很多比赛是在北京时间的凌晨进行的，所以为了能及时购票，请您在每天晚上10前下单，方便我们业主朋友打票',
              disabled: false
            },
            {
              question: '店长推荐的内容从哪里来的？',
              answer: '店长推荐是与您绑定的彩店业主为您定制的跟单方案。若您不懂球却想跟单购买，那跟着业主购买无疑是最有效的方式。您可以从业主推荐的方案中，选择合适的方案进行计划下单。购彩有风险，所以一定要谨慎投注哦~',
              disabled: false
            },
            {
              question: '能否查询方案的历史数据？',
              answer: '当然可以！启动【彩点助手-彩友版APP】，点击“店长推荐”，点击任何方案，在方案详情页中，右上角会默认显示当前日期，例如“2018-02”，表示当前看到的数据是2018年2月的，点击日期后选择合适的月份即可查看其他月份的数据。',
              disabled: false
            },
            {
              question: '什么是方案投注？',
              answer: '方案投注就是跟着专家方案进行计划投注，对于不太懂球的彩友朋友来说是最方便最有效的投注方式。您只需要在“店长推荐”中选择适合的方案，点击“提交彩店”按钮，在投注信息界面选择投注倍数，核对投注金额是否正确，若正确即可下单。记住，任何方案都有截单时间，所以请务必在截单时间前下单哦~',
              disabled: needDisabled
            },
            {
              question: '什么是自助下单？',
              answer: '自由投注就是自由组合场次和结果的投注，对于懂球爱好足球的彩友朋友来说是更为刺激和有趣的投注方式。启动【彩点助手-彩友版APP】中，点击“自助下单”区域中的“竞彩足球”，即可看到场次选择界面，除胜负平和让球胜负平玩法外，还可以点击“展开全部”选择比分、总进球或半全场玩法。需要注意的是，带红框的场次表示单关场次，说明可以选一场就能下单。带黑框的场次不是单关场次，所以要至少选择2场才能下单。',
              disabled: needDisabled
            },
            {
              question: '什么是单关？',
              answer: '单关指的是只对一场比赛结果进行投注。官方规定的单关比赛通常是开放了胜平负玩法的单关（只选胜平负中的结果即可投注这一场比赛，其它非单关比赛通常要串2场及2场以上的比赛），在自由投注中，带红框的场次就是单关场次。还有一种单关是指对一场比赛的比分、半全场、进球数进行投注，此时也可以对单场比赛进行投注。',
              disabled: false
            },
            {
              question: '什么叫胆？',
              answer: '胆，是彩票术语中的一种。在竞猜型彩票中表示你比较看好，出现的几率高一点的比赛结果，称之为胆。取有胆量确定号码就是对的之意哦。<br>' +
              '定胆可减少成本，例如：你选3场比赛，选2串1，那么就是3注，6元。如果你定胆三场中一场，那么就变成用胆和另两场组合成2注2串1了，4元，省了两元。定胆之后，成本少了，奖金也变少了，而且胆错则不可能中奖。<br>',
              disabled: false
            },
            {
              question: '奖金优化有什么作用？',
              answer: '奖金优化就是针对投注的复式倍投方案，您根据自己的需求，自行对单注注数进行分配的功能。彩点助手提供了三种快捷的优化方式：平均优化、博热优化和博冷优化，它们的说明和区别如下。<br>' +
              '平均优化：以方案单注奖金趋于平均的规则进行优化。<br>' +
              '博热优化：在方案单注保本前提下，使概率最高的单注奖金最大化。<br>' +
              '博冷优化：在方案单注保本前提下，使奖金最高的单注奖金最大化。<br>',
              disabled: needDisabled
            },
            {
              question: '奖金优化支持哪些过关方式？',
              answer: '奖金优化最多支持10场比赛的串关优化，但“博热优化”和“博冷优化”暂不支持组合过关。',
              disabled: needDisabled
            },
            {
              question: '奖金优化是否支持设胆？',
              answer: '奖金优化不支持用户进行设胆。',
              disabled: needDisabled
            },
            {
              question: '奖金优化后的方案是否会赔钱?',
              answer: '不一定。中奖的基本条件，是您选的原始方案是中奖的。如果您的原始方案没有中，那优化后的方案也是不会中奖的，所以肯定也是要赔钱的。',
              disabled: needDisabled
            },
            {
              question: '如何查看自己的订单状态？',
              answer: '在【彩点助手-彩友版APP】中您可以随时跟踪每个订单的实时状态。启动APP，进入“我的订单”界面，将看到订单分为了四类，分别是跟单、合买、自购和中奖。您可以根据类型查找到您所有历史订单。',
              disabled: needDisabled
            },
            {
              question: '如何支付？',
              answer: '【彩点助手-彩友版APP】是个合规合法的软件，目前不支持任何线上支付功能，我们的彩店业主也都是经过实名认证的真实业主，因此您可以通过微信或支付宝转账等方式进行订单支付。',
              disabled: needDisabled
            },
            {
              question: '可以查看订单的出票情况吗？',
              answer: '完全可以！请先关注【彩点助手-微信公众号】，这样只要订单完成了出票，您将收到公众号发来“出票成功通知”的消息提醒。【彩点助手-彩友版APP】也将收到“您有一个订单已出票，等待开奖吧~”的推送消息提醒，这时您打开APP进入订单详情页，点击“查看详情”按钮，就能看到彩店业主上传的出票照片。',
              disabled: needDisabled
            },
            {
              question: '如何派奖？',
              answer: '【彩点助手-彩友版APP】是个合规合法的软件，目前不支持任何线上支付功能，我们的彩店业主也都是经过实名认证的真实业主，因此您大可放心，彩店业主会通过微信或支付宝转账等方式将奖金送到您手中。',
              disabled: needDisabled
            }
          ]
        }
      ],
      showQuestionList: []
    }
  },
  methods: {
    // 修改版本
    changeType (index) {
      this.showType = index
      this.pageNo = 1
      this.changeShowQuestionList()
      $('.question img').removeClass('showAnswer')
      $('.answer').hide()
    },
    // 查看答案
    changeShowAnswer (i, event) {
      let answerDom
      if (event.target.tagName === 'IMG') {
        $(event.target).toggleClass('showAnswer')
        answerDom = event.target.parentElement.nextElementSibling
      } else {
        $(event.target).find('img').toggleClass('showAnswer')
        answerDom = event.target.nextElementSibling
      }
      $(answerDom).slideToggle(400)
    },
    // 改变显示的问答
    changeShowQuestionList () {
      this.pageNums = Math.ceil(this.helpList[this.showType].questionsAndAnswers.length / this.pageSize)
      let start = (this.pageNo - 1) * this.pageSize
      let end = this.pageNo * this.pageSize
      this.showQuestionList = this.helpList[this.showType].questionsAndAnswers.slice(start, end)
    },
    // 改变页数
    changePage (index) {
      this.pageNo = index
      this.changeShowQuestionList()
    }
  },
  created () {
    this.changeShowQuestionList()
  }
}
</script>

<style scoped lang="less">
  .helpTutorials{
    position: relative;
    padding-bottom: 50px;
    >.head{
      height: 90px;
      border-bottom: 1px solid #dedede;
      padding: 25px 0;
      box-sizing: border-box;
      color: #5E5E5E;
      span{
        margin: 0 25px;
        font-size: 28px;
        line-height: 40px;
        font-weight: bold;
      }
      >span{
        padding-right: 20px;
        border-right: 1px solid #5E5E5E;
      }
      >p{
        cursor: pointer;
        color: #BBBBBB;
        float: right;
        >.active{
          color: #5E5E5E;
        }
      }
    }
    >.content{
     padding: 50px;
      li{
        border-bottom: 1px solid #dddddd;
        font-size: 20px;
        line-height: 30px;
        >p:nth-of-type(1){
          margin-top: 10px;
          color: #101010;
          cursor: pointer;
          img{
            width: 20px;
            vertical-align: middle;
            margin: 5px;
            transition: all .5s;
          }
          img.showAnswer{
            transform: rotateZ(90deg);
          }
        }
        >p:nth-of-type(2){
          color: #5E5E5E;
          padding: 10px 20px;
          display: none;
        }
      }
    }
    >.paging{
      position: absolute;
      bottom: 40px;
      left: 50%;
      transform: translateX(-50%);
      font-size: 18px;
      height: 20px;
      color: #bbbbbb;
      li{
        float: left;
        width: 30px;
        height: 30px;
        border: 1px solid #dddddd;
        margin: 0 4px;
        line-height: 30px;
        text-align: center;
        border-radius: 3px;
        cursor: pointer;
      }
      li.active{
        background-color: #383838;
        color: #fff;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/helpTutorials.vue